import * as yup from 'yup';

import { USERNAME_REQUIRED } from './schema-errors';

export const usernameOnlySchema = yup.object({
	username: yup.string().required(USERNAME_REQUIRED),
});
